import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

type Props = {
    children: React.ReactNode;
    align?: "left" | "right" | "center";
    sx?: SxProps<Theme>;
};

const AppTableHeaderCell = ({ children, align = "left", sx }: Props) => {
    return (
        <Box
            component="th"
            sx={(theme) => ({
                textAlign: align,
                px: 2,
                py: 1.5,
                color: theme.palette.text.secondary,
                fontWeight: 600,
                fontSize: "0.75rem",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                backgroundColor: theme.palette.background.paper,
                ...((typeof sx === "function" ? sx(theme) : sx) as any),
            })}
        >
            {children}
        </Box>
    );
};

export default AppTableHeaderCell;